import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { environment } from "../../../environments/environment";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { HttpClient } from "@angular/common/http";
import { ResumeComponent } from "./resume.component";
import { InvoiceService } from "../invoice/invoice/invoice.service";
import { InvoiceModel } from "../invoice/invoice/invoice.model";
import { InvoiceDialogPaidedComponent } from '../invoice/invoice/invoice-dialog-paided.component';
import { TicketModel } from '../invoice/tickets/ticket.model';
import * as FileSaver from 'file-saver';
import { ResumeService } from './resume.service';
import { ResumeDialogConst } from './const';
import { CoreComponent } from '../../core/header/core.component';
import { ActualSelected, Utils } from '../../shared/utils';
import { SalaryService } from '../expense/salary/salary.service';
import { SelfEmployedService } from '../expense/selfemployed/selfemployed.service';
import { SalaryModel } from '../expense/salary/salary.model';
import { SelfEmployedModel } from '../expense/selfemployed/selfemployed.model';
import { ExpensesSalaryConst, ExpensesSelfEmployedConst } from '../expense/const';
import { consts } from '../../consts';
import { AddFileService } from '../../shared/components/add-file/add-file.service';
import { TicketService } from '../invoice/tickets/ticket.service';

@Component({
    selector: 'convfact-resume-dialog',
    templateUrl: './resume-dialog.component.html',
    styleUrls: ['./resume.component.css'],
    providers: [CoreComponent],
    standalone: false
})
export class ResumeDialogComponent implements OnInit {
  ready: boolean = false;
  dataSource: InvoiceModel[] = [];
  dataSourceTicketsOriginal: TicketModel[] = [];
  incomesPaided: boolean = this.data.incomesPaided;
  incomesNoPaided: boolean = this.data.incomesNoPaided;
  expensesPaided: boolean = this.data.expensesPaided;
  expensesNoPaided: boolean = this.data.expensesNoPaided;
  activityUid: string = this.data.activityUid;
  monthsSelected: string = this.data.monthsSelected;
  showGlobal: boolean = this.data.showGlobal;

  clientUid: string = this.data.clientUid;

  sentence: string = "";
  mes: string = "";
  invoicesCSV: string[] = [];
  invoice: InvoiceModel;

  headerTable: any[] = ResumeDialogConst.headerTable;
  headerTableInvoices: any[] = ResumeDialogConst.headerTableInvoices;
  salaryTable: any[] = ExpensesSalaryConst.headerTable;
  selfEmployedTable: any[] = ExpensesSelfEmployedConst.headerTable;

  salary = false;
  selfEmployed = false;
  expenses = false;

  salaries: SalaryModel[] = [];
  selfEmployeds: SelfEmployedModel[] = [];

  salariesDataSource: SalaryModel[] = [];
  selfEmployedsSource: SelfEmployedModel[] = [];

  salaryReady = false;
  selfEmployedReady = false;

  private ticket: TicketModel;

  constructor(
    public dialogRef: MatDialogRef<ResumeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    public snackBar: MatSnackBar,
    private invoiceService: InvoiceService,
    private resumeService: ResumeService,
    private AddFileService: AddFileService,
    public dialog: MatDialog,
    public core: CoreComponent,
    private salaryService: SalaryService,
    private selfEmployedService: SelfEmployedService,
    private ticketService: TicketService
  ) { }

  //Interacciones con la tabla------------------------------------------------------

  onInvoiceNumberClick(invoiceNumber) {
    this.invoice = invoiceNumber;
    this.pdf(this.invoice.uid); // Llamar a la función pdf con el uid de la preinvoice
  }


  onAmountNumberClick(invoiceNumber) {
    if (invoiceNumber.isReceptor) {
      this.invoicePaidedExpense(invoiceNumber.uid);
    } else {
      this.invoicePaided(invoiceNumber.uid, false);
    }
  }

  //-------------------------------------------------------------------------------

  goExpenses() {
    this.selfEmployed = false;
    this.salary = false;
    this.expenses = true;
  }

  goSelfEmployed() {
    this.selfEmployed = true;
    this.salary = false;
    this.expenses = false;
    const self = this;
    this.selfEmployedReady = false;

    this.resumeService.getSelfEmployedPaided(this.showGlobal, this.clientUid).then(result => {
      self.selfEmployedsSource = result;
      self.selfEmployedReady = true;
    })
  }

  goSalary() {
    this.selfEmployed = false;
    this.salary = true;
    this.expenses = false;
    const self = this;

    this.resumeService.getSalariesPaided(this.showGlobal, this.clientUid).then(result => {
      self.salariesDataSource = result;
      self.salaryReady = true;
    })
  }

  closeDialog() {
    this.dialogRef.close();
  }

  invoicePaided(uid: string, isTicket: boolean): void {
    const invoicePaidedref = this.dialog.open(InvoiceDialogPaidedComponent, {
      // height: '450px',
      data: {
        uid: uid,
        isInvoice: isTicket == true ? false : true, // Si es un ticket no puede ser una factura
        isTicket: isTicket,
        isIncome: true,
        isMultiple: false
      },
    });

    invoicePaidedref.afterClosed().subscribe(result => {
      this.ngOnInit();
    })
  }

  invoicePaidedExpense(uid: string): void {
    const invoicePaidedref = this.dialog.open(InvoiceDialogPaidedComponent, {
      // height: '450px',
      data: { uid: uid, isInvoice: true, isTicket: false, isMultiple: false },
    });

    invoicePaidedref.afterClosed().subscribe(result => {
      this.ngOnInit();
    })
  }

  displayInfo(response: string, time: number = 10500): void {
    const options = new MatSnackBarConfig();
    options.duration = time;
    this.snackBar.open(response, '', options);
  }

  getFileNameExport(sufix: string = ""): string {
    return Utils.GetExcelName(this.sentence.trim() + "_" + sufix);
  }

  public exportSelfEmployed() {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.selfEmployedsSource.forEach(invoice => {
      this.invoicesCSV.push(invoice.uid);
    })
    this.selfEmployedService.export(this.invoicesCSV, this.clientUid).then(response =>
      FileSaver.saveAs(response, this.getFileNameExport('Autonomo'))
    );
  }

  public exportSalary() {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.salariesDataSource.forEach(invoice => {
      this.invoicesCSV.push(invoice.uid);
    })
    this.salaryService.export(this.invoicesCSV, this.clientUid).then(response =>
      FileSaver.saveAs(response, this.getFileNameExport('Nomina'))
    );
  }

  public export() {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.invoicesCSV = [];
    this.dataSource.forEach(invoice => {
      this.invoicesCSV.push(invoice.uid);
    })

    if (this.invoicesCSV.length === 0) {
      this.displayInfo('No se ha encontrado ninguna factura a exportar', 2000)
      return;
    }

    if (this.sentence.includes('Ingresos no cobrados') || this.sentence.includes('Ingresos cobrados')) {
      this.resumeService.exportIncomesResumeTable(this.invoicesCSV, this.clientUid).then(response =>
        FileSaver.saveAs(response, this.getFileNameExport())
      ).catch(err => {
        this.displayInfo('Ha ocurrido un error inesperado al exportar el documento excel', 3000);
        this.ready = true;
      });
    }

    if (this.sentence.includes('Gastos no pagados') || this.sentence.includes('Gastos pagados')) {
      this.resumeService.exportExpensesResumeTable(this.invoicesCSV, this.clientUid).then(response =>
        FileSaver.saveAs(response, this.getFileNameExport())
      ).catch(err => {
        this.displayInfo('Ha ocurrido un error inesperado al exportar el documento excel', 3000);
        this.ready = true;
      });
    }
  }

  public exportExpiration(type: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.invoicesCSV = [];
    this.dataSource.forEach(invoice => {
      if (invoice.invoiceExpiration !== undefined) {

        const actualDateInit = new Date();
        actualDateInit.setHours(0, 0, 0, 0);
        const actualDate = new Date(actualDateInit.toISOString());

        const expirationDateInit = new Date(invoice.invoiceExpiration);
        expirationDateInit.setHours(0, 0, 0, 0);
        const expirationDate = new Date(expirationDateInit.toISOString());

        const datefromAPITimeStamp = (new Date(expirationDate)).getTime();
        const nowTimeStamp = actualDate.getTime();

        const microSecondsDiff = Math.abs(datefromAPITimeStamp - nowTimeStamp);
        const daysDiff = Math.round(microSecondsDiff / (1000 * 60 * 60 * 24));

        if (daysDiff > 0 && daysDiff <= 5) {
          this.invoicesCSV.push(invoice.uid);
        }
      }
    })

    if (this.invoicesCSV.length === 0) {
      this.displayInfo('No se ha encontrado ninguna factura a exportar', 2000)
      return;
    }

    if (type === 'incomes') {
      this.resumeService.exportIncomesResumeTable(this.invoicesCSV, this.clientUid).then(response =>
        FileSaver.saveAs(response, this.getFileNameExport('_Vencimiento a 5 días'))
      ).catch(err => {
        this.displayInfo('Ha ocurrido un error inesperado al exportar el documento excel de facturas', 3000);
        this.ready = true;
      });
    }

    if (type === 'expenses') {
      this.resumeService.exportExpensesResumeTable(this.invoicesCSV, this.clientUid).then(response =>
        FileSaver.saveAs(response, this.getFileNameExport('_Vencimiento a 5 días'))
      ).catch(err => {
        this.displayInfo('Ha ocurrido un error inesperado al exportar el documento excel de gastos', 3000);
        this.ready = true;
      });
    }
  }

  sendRememberEmail(uid: string): void {
    this.invoiceService.rememberPdfMail(uid).then(response => {
      this.displayInfo(response);
    })
  }

  pdfMail(uid: string): void {
    this.invoiceService.pdfMail(uid).then(response => {
      this.displayInfo(response);
    })
  }

  pdf(uid: string): void {
    this.invoiceService.loadData(uid).then(response => {
      this.invoice = response
    });
    this.invoiceService.pdf(uid, this.clientUid).then(response => {
      FileSaver.saveAs(response, Utils.GetPdfName(this.invoice.invoiceNumber));
    })
  }

  pdfTicket(uid: string): void {
    this.ticketService.loadData(uid).then(response =>
      this.ticket = response);

    this.ticketService.pdf(uid).then(response => {
      FileSaver.saveAs(response, Utils.GetPdfName("Ticket_" + this.ticket.ticketNumber));
    })
  }

  downloadFileImage(uid: string): void {
    this.AddFileService.downloadFileImage(uid, consts.INVOICE_ENTITY, consts.EMPTY_GUID).then(response => {
      FileSaver.saveAs(response, Utils.GetFileName("Gasto", consts.EXT_PNG));
    })
  }

  downloadFilePdf(uid: string): void {
    this.AddFileService.downloadFilePDF(uid, consts.INVOICE_ENTITY, consts.EMPTY_GUID).then(response => {
      FileSaver.saveAs(response, Utils.GetPdfName("Gasto"));
    })
  }

  ngOnInit() {
    this.ready = false;

    if (this.clientUid == null) {
      this.clientUid = consts.EMPTY_GUID;
    }

    this.dataSource = [];

    if (this.expensesPaided == true) {
      this.sentence = "Gastos pagados";
      this.resumeService.getExpensesPaided(this.showGlobal, this.clientUid).then(response => {
        this.dataSource = response;
        this.ready = true;
        this.expenses = true;
      })
    }

    if (this.expensesNoPaided == true) {
      this.sentence = "Gastos no pagados";
      this.ready = false;
      this.dataSource = [];

      this.resumeService.getExpensesPending(this.showGlobal, this.clientUid).then(response => {
        this.dataSource = response;
        this.ready = true;
        this.expenses = true;
      })
    }

    if (this.incomesPaided == true) {
      this.sentence = "Ingresos cobrados";
      this.ready = false;
      this.dataSource = [];

      this.resumeService.getIncomesPaided(this.showGlobal, this.clientUid).then(response => {
        this.dataSource = response;
        this.resumeService.getIncomesTicketsPaided(this.showGlobal, this.clientUid).then(response => {
          this.dataSourceTicketsOriginal = response;

          this.dataSourceTicketsOriginal.forEach(ticket => {
            const temp = new InvoiceModel();
            temp.invoiceNumber = ticket.ticketNumber;
            temp.receiverName = "Factura simplificada"; // Con esto sabemos que es un ticket
            temp.invoiceRelease = ticket.date;
            temp.total = ticket.total;
            temp.totalPaided = ticket.totalPaided;
            temp.base = ticket.base;
            temp.uid = ticket.uid;

            this.dataSource.push(temp);
          })

          this.ready = true;
          this.expenses = true;
        });
      });
    }

    if (this.incomesNoPaided == true) {
      this.sentence = "Ingresos no cobrados";

      this.ready = false;
      this.dataSource = [];
      this.resumeService.getIncomesPending(this.showGlobal, this.clientUid).then(response => {
        this.dataSource = response;
        this.resumeService.getIncomesTicketsPending(this.showGlobal, this.clientUid).then(response => {
          this.dataSourceTicketsOriginal = response;

          this.dataSourceTicketsOriginal.forEach(ticket => {
            const temp = new InvoiceModel();
            temp.invoiceNumber = ticket.ticketNumber;
            temp.receiverName = "Factura simplificada"; // Con esto sabemos que es un ticket
            temp.invoiceRelease = ticket.date;
            temp.total = ticket.total;
            temp.totalPaided = ticket.totalPaided;
            temp.base = ticket.base;
            temp.uid = ticket.uid;
            this.dataSource.push(temp);
          })

          this.ready = true;
          this.expenses = true;
        })
      })
    }

  }

  expensePaidedSelected(selectedUids: string[]) {
    // Eliminamos los que ya estan pagados
    const dataSelected = this.dataSource.filter(row => selectedUids.includes(row.uid) && row.paided == null);
    selectedUids = dataSelected.map(row => row.uid);

    // Obtenemos el monto restante a pagar de los elementos válidos seleccionados
    let amountSelectedUnpaid: number = 0;
    for (let i = 0; i < dataSelected.length; i++) {
      amountSelectedUnpaid += Utils.GetValueWithDecimals((dataSelected[i].total - dataSelected[i].totalPaided));
    }

    if (selectedUids.length > 0) {
      this.dialog.open(InvoiceDialogPaidedComponent, {
        //height: '450px',
        data: { selectedUids: selectedUids, isInvoice: true, isMultiple: true, amountSelectedUnpaid: amountSelectedUnpaid }
      }).afterClosed().subscribe(() => {
        this.ngOnInit();
      });
    } else {
      this.displayInfo('No tienes ningun gasto válido seleccionado', 3000);
    }
  }

  invoicePaidedSelected(selectedUids: string[]) {
    // Eliminamos los que ya estan pagados y los que estan rectificados
    const dataSelected = this.dataSource.filter(row => selectedUids.includes(row.uid) && row.paided == null);
    selectedUids = dataSelected.map(row => row.uid);

    let hasInvoice: boolean = false;
    let hasTicket: boolean = false;

    // Obtenemos el monto restante a pagar de los elementos válidos seleccionados
    let amountSelectedUnpaid: number = 0;
    for (let i = 0; i < dataSelected.length; i++) {
      if (dataSelected[i].invoiceExpiration === undefined && dataSelected[i].receiverName === 'Factura simplificada') {
        hasTicket = true;
      }
      if (dataSelected[i].invoiceExpiration !== undefined) {
        hasInvoice = true;
      }
      amountSelectedUnpaid += Utils.GetValueWithDecimals((dataSelected[i].total - dataSelected[i].totalPaided));
    }

    // Verficamos que se ha seleccionado unicamente facturas o tickets, no admitimos que se seleccionen ambos tipos
    if (hasInvoice === true && hasTicket === true) {
      this.displayInfo('No se puede realizar el cobro de facturas y tickets', 2500);
      return;
    }

    // Como en el listado tendremos tanto facturas como tickets,
    let modalData = undefined;
    if (hasInvoice === true) {
      modalData = { selectedUids: selectedUids, isInvoice: true, isTicket: false, isIncome: true, isMultiple: true, amountSelectedUnpaid: amountSelectedUnpaid };
    }
    if (hasTicket === true) {
      modalData = { selectedUids: selectedUids, isIncome: true, isTicket: true, isMultiple: true, amountSelectedUnpaid: amountSelectedUnpaid };
    }

    if (modalData === undefined) {
      this.displayInfo('Ha ocurrido un error inesperado', 2000);
      return;
    }

    if (selectedUids.length > 0) {
      const invoicePaidedMultipleref = this.dialog.open(InvoiceDialogPaidedComponent, {
        //height: '450px',
        data: modalData,
      });

      invoicePaidedMultipleref.afterClosed().subscribe(result => {
        this.ngOnInit();
      })
    } else {
      this.displayInfo('No tienes ninguna factura válida seleccionada', 2000);
    }
  }
  public trackByIndex(i: number) { return i; }

}
